import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PostingAccount.Save.IRequest;
type Response = Api.Core.PostingAccount.Save.IResponse;
type Headers = Api.Core.PostingAccount.Save.IHeaders;
const url = '/api/Finance/LedgerAccount';
export default async function postingAccountSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
